import type { FC } from "react"

import { cn } from "@productlane/lib/src/cn"

import type { SelectProps } from "./types"
import { api } from "@/lib/api"
import { Select } from "./select"

export const StageSelect: FC<SelectProps & { className?: string }> = ({
	item,
	onChange,
	align = "end",
	side = "right",
	modal,
	className,
}) => {
	const customerStatusesQuery = api.linear.customerStatuses.useQuery(
		undefined,
		{
			cacheTime: Infinity,
			staleTime: Infinity,
		},
	)

	const customerStatuses =
		customerStatusesQuery.data?.customerStatuses.nodes || []

	return (
		<div
			className={cn("flex h-7 items-center text-sm text-secondary", className)}
		>
			<div className="w-full">
				<Select
					align={align}
					side={side}
					modal={modal}
					label="stage"
					onChange={onChange}
					item={item}
					items={customerStatuses}
					Icon={({ color }: { color?: string }) => (
						<span
							style={{ backgroundColor: color || (item?.color ?? undefined) }}
							className="ml-[3px] mr-1 h-2 w-2 shrink-0"
						/>
					)}
				/>
			</div>
		</div>
	)
}
